import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { ChangePassComponent } from './views/change-pass/change-pass.component';
import { ThongKeComponent } from './views/thongke/thongke.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'map/duongbo',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./views/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: 'jobs',
        loadChildren: () => import('./views/jobs/jobs.module').then(m => m.JobsModule)
      },
      {
        path: 'map',
        loadChildren: () => import('./views/bando/bando.module').then(m => m.BanDoModule)
      },
      {
        path: 'duongbo',
        loadChildren: () => import('./views/duongbo/duongbo.module').then(m => m.DuongBoModule)
      },
      {
        path: 'dth',
        loadChildren: () => import('./views/dth/dth.module').then(m => m.DenTinHieuModule)
      },
      {
        path: 'tochucgiaothong',
        loadChildren: () => import('./views/tochucgiaothong/tochucgiaothong.module').then(m => m.ToChucGiaoThongModule)
      },
      {
        path: 'kehoach',
        loadChildren: () => import('./views/kehoach/kehoach.module').then(m => m.KeHoachModule)
      },
      {
        path: 'doc',
        loadChildren: () => import('./views/doc/doc.module').then(m => m.DocModule)
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },
      {
        path: 'change-pass',
        loadChildren: () => import('./views/change-pass/change-pass.module').then(m => m.ChangePassModule)
      },
      {
        path: 'thongke',
        loadChildren: () => import('./views/thongke/thongke.module').then(m => m.ThongKeModule)
      },
      {
        path: 'dynamic',
        loadChildren: () => import('./views/dynamic/dynamic.module').then(m => m.DynamicModule)
      },
      {
        path: 'draw',
        loadChildren: () => import('./views/draw/draw.module').then(m => m.DrawModule)
      },
      {
        path: 'donvi',
        loadChildren: () => import('./views/donvi/donvi.module').then(m => m.DonviModule)
      },
      {
        path: 'caulon',
        loadChildren: () => import('./views/caulon/caulon.module').then(m => m.CauLonModule)
      },
      {
        path: 'report',
        loadChildren: () => import('./views/report/report.module').then(m => m.ReportModule)
      },
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
